import React, { useState, useMemo } from "react";
import {
  Box,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import moment from "moment";

export default function TableDetailInvest({ investments = [] }) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = newPage => {
    setPage(newPage);
  };

  const noData = () => (
    <Box
      sx={{
        width: "100%",
        height: 70,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <ManageSearchIcon sx={{ color: "#737791" }} />
      <Typography
        variant="body1"
        color="#737791"
      >
        Sin datos por mostrar
      </Typography>
    </Box>
  );

  const totalPages = Math.ceil(investments.length / rowsPerPage);

  return (
    <>
      <Paper sx={{ width: "100%", padding: 3 }}>
        {investments && investments.length
          ? <>
            <TableContainer
              className="table-content"
              components={{
                Container: props => <Paper {...props} elevation={0} />
              }}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Método</TableCell>
                    <TableCell>Monto</TableCell>
                    <TableCell>Tipo de monto</TableCell>
                    <TableCell>Monto Inversión</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? investments.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                    : investments
                  ).map((row, i) => {
                    return (
                      <TableRow
                        key={i}
                        sx={{ "& td, & th": { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {moment(row.date).format("DD/MM/YYY")}
                        </TableCell>
                        <TableCell>{row.metodo}</TableCell>
                        <TableCell>${row.monto.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                        <TableCell>{row.tipo}</TableCell>
                        <TableCell>${row.monto.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      </TableRow>
                    )
                  }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Stack className="pagination" spacing={2} mt={3}>
                <Pagination
                  sx={{ width: "100%" }}
                  color="primary"
                  shape="rounded"
                  count={totalPages}
                  onChange={(event, value) => handleChangePage(value)}
                  page={page}
                  size="large"
                />
              </Stack>
            </Box>
          </>
          : noData()
        }
      </Paper>
    </>
  );
}
